/* src/app/system-utils/grid-selector/grid-selector.component.css */
.selector-main {
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: var(--tem-font-family);
}
.lists-row {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: stretch;
}
.list-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-surface);
  overflow: hidden;
}
.list-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: var(--tem-surface-2);
  border-bottom: 1px solid var(--tem-border);
  font-weight: 600;
}
.list-count {
  font-size: var(--tem-fs-sm, 12px);
  color: var(--tem-muted);
}
.column-list {
  display: flex;
  flex-direction: column;
  height: 420px;
  overflow-y: auto;
  padding: 8px 12px;
  gap: 6px;
}
.column-list label {
  margin: 0;
}
.transfer-buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
}
.btnConfCancel {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 10px;
}
/*# sourceMappingURL=grid-selector.component.css.map */
